import { Checkbox, Card, Typography } from 'antd';
import { Question, QuestionOptions, EffectiveChoiceItem } from '../../types/survey.types';
import './ChoiceOptions.css';

// Phase 6 - US4: Checkbox Question Component (T115)

interface CheckboxQuestionProps {
  question: Question;
  values: string[];
  onChange: (values: string[]) => void;
  /** Spec 033: lista já filtrada (botões de filtro + filtro digitado) a ser exibida. */
  visibleChoices?: EffectiveChoiceItem[];
}

const CheckboxQuestion = ({ question, values, onChange, visibleChoices }: CheckboxQuestionProps) => {
  const opts = question.options as QuestionOptions | undefined;
  const choices =
    visibleChoices ??
    (question.effectiveChoices && question.effectiveChoices.length > 0
      ? question.effectiveChoices
      : opts?.choices || []);

  const maxSelections = opts?.maxSelections ?? 0;
  const enforceSelectionLimit = Boolean(opts?.enforceSelectionLimit);

  const limitLabel =
    maxSelections > 0
      ? enforceSelectionLimit
        ? `Obrigatório ${maxSelections} opções`
        : `Limite de escolha: ${maxSelections} opções`
      : null;

  const limitReached = maxSelections > 0 && values.length >= maxSelections;

  return (
    <>
      {limitLabel && (
        <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
          {limitLabel}
        </Typography.Text>
      )}
      <Checkbox.Group value={values} onChange={onChange} style={{ width: '100%' }}>
        <div className="choice-options-grid">
          {choices.map((choice) => {
            const isSelected = values.includes(choice.value);
            const isDisabled = limitReached && !isSelected;
            const cardClassName = [
              'choice-option-card',
              isSelected && 'choice-option-card--selected',
              isDisabled && 'choice-option-card--disabled',
            ]
              .filter(Boolean)
              .join(' ');

            return (
              <Card
                key={choice.value}
                className={cardClassName}
                onClick={() => {
                  if (isDisabled) return;
                  const newValues = isSelected
                    ? values.filter((v) => v !== choice.value)
                    : [...values, choice.value];
                  onChange(newValues);
                }}
                styles={{ body: { padding: '12px 16px' } }}
              >
                <Checkbox value={choice.value} checked={isSelected} disabled={isDisabled}>
                  <span className="choice-option-label">{choice.label}</span>
                </Checkbox>
              </Card>
            );
          })}
        </div>
      </Checkbox.Group>
    </>
  );
};

export default CheckboxQuestion;
